<template>
  <div
    class="w-full h-full relative overflow-auto bg-gradient-to-br from-slate-50 via-white to-slate-100"
  >
    <!-- Decorative background elements -->
    <div class="fixed inset-0 overflow-hidden pointer-events-none">
      <div
        class="absolute top-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"
      ></div>
      <div
        class="absolute bottom-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"
      ></div>
    </div>

    <div
      class="w-full min-h-full flex flex-col items-center justify-center relative overflow-auto py-8 md:py-12 px-4"
      :class="{
        '[&_.mobile-status-padding]:pt-12 [&_.mobile-bottom-padding]:pt-8 [&_.mobile-status-padding-mt]:mt-12':
          $stores.shared?.state?.isAndroidApp
      }"
    >
      <div class="mobile-status-padding"></div>
      <div class="flex justify-center py-6 md:py-8">
        <div class="w-20 h-20 md:w-24 md:h-24 drop-shadow-lg">
          <ImgComponent
            src="/images/logo.png"
            class="bg-white rounded-2xl w-full h-full"
            alt=""
          />
        </div>
      </div>

      <div class="w-full max-w-md">
        <div class="text-center mb-8">
          <h1 class="text-3xl md:text-4xl font-bold title-color tracking-tight">
            <slot name="title"></slot>
          </h1>
        </div>

        <div
          class="bg-white/80 backdrop-blur-xl rounded-2xl shadow-sm border border-slate-100 p-6 md:p-8"
        >
          <slot></slot>
        </div>

        <div class="text-center pt-6 md:pt-8 space-y-2">
          <div>
            <span class="text-slate-600">
              <slot name="redirectQuestion"></slot>
            </span>

            <router-link
              to="/register"
              class="text-primary font-semibold hover:text-primary-600 transition-colors"
            >
              <slot name="redirectLink"></slot>
            </router-link>
          </div>
          <div class="text-primary font-semibold">
            <slot name="aditionnalAction"></slot>
          </div>
        </div>
        <div class="text-center pt-6 md:pt-8 space-y-2">
          <slot name="superAction"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
